import { get, map } from 'lodash';
import { createSelector } from 'reselect';
import { LOCATION_TYPES } from './constants';

const toNotificationTemplate = notification => ({
  frequency: notification.frequency,
  frequencyUnit: notification.frequencyUnit,
  id: notification.id,
  idleTime: notification.idleTime,
  locationName: LOCATION_TYPES.toString(notification.locationTypeId),
  locationTypeId: notification.locationTypeId,
  isActive: notification.isActive,
  tempId: notification.tempId,
  text: notification.text,
  timeOfDay: notification.timeOfDay ? notification.timeOfDay : null,
});

const notificationTemplatesSliceSelector = state =>
  get(state, ['dal', 'notificationTemplates']);

export const notificationTemplatesSelector = createSelector(
  [notificationTemplatesSliceSelector],
  notificationTemplates => map(notificationTemplates, toNotificationTemplate),
);



// WEBPACK FOOTER //
// ./src/lib/dataLayer/notificationTemplates/selectors.js